import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { Icon,  RowView } from "../../../../Component/style/common_style";
import { useNavigate } from "react-router-dom";
import { amountFormat } from "../../../../Component/tool/Tools";
import React, { useState } from "react";
import CheckModal from "./CheckModal";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";

interface CoinChargeModalProps extends modalProps {
  myCoin: number | null;
  handleReload: () => void;
}

const CoinChargeModal = ({
  visible,
  handleModal,
  myCoin,
  handleReload,
}: CoinChargeModalProps) => {
  const Navigate = useNavigate();
  const goHome = () => Navigate("/");

  const [chargeCoin, setChargeCoin] = useState(500);
  const handleChargeCoin = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChargeCoin(Number(e.target.value));
  };
  const [select, setSelect] = useState(0);

  const closeModal = () => {
    handleModal();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const [checkVisible, setCheckVisible] = useState(false);
  const handleCheckModal = () => {
    setCheckVisible(!checkVisible);
  };

  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox role="dialog" aria-modal="true" aria-label="코인 충전" onClick={stopPropagation}>
        <ModalHeader>
        <Title>
          코인 충전
          <ModalCloseButton tone="admin" aria-label="코인 충전 닫기" className="btn" onClick={closeModal} />
        </Title>
        </ModalHeader>
        <ModalBody>
        <MyCoinDiv>
          보유 코인
          <div className="blue">{myCoin === null ? '조회 필요' : `${amountFormat(myCoin)}C`}</div>
        </MyCoinDiv>
        <Title style={{ marginTop: 40 }}>충전 코인</Title>
        <CoinGrid>
          <SelectDiv
            $select={select === 0}
            onClick={() => {
              setChargeCoin(500);
              setSelect(0);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-family-base)",
              }}
            >
              <Icon
                src={
                  select === 0
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              500C
            </RowView>
            50,000원
          </SelectDiv>
          <SelectDiv
            $select={select === 1}
            onClick={() => {
              setChargeCoin(1000);
              setSelect(1);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-family-base)",
              }}
            >
              <Icon
                src={
                  select === 1
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              1,000C
            </RowView>
            100,000원
          </SelectDiv>

          <SelectDiv
            $select={select === 2}
            onClick={() => {
              setChargeCoin(2000);
              setSelect(2);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-family-base)",
              }}
            >
              <Icon
                src={
                  select === 2
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              2,000C
            </RowView>
            200,000원
          </SelectDiv>
          <SelectDiv
            $select={select === 3}
            onClick={() => {
              setChargeCoin(3000);
              setSelect(3);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-family-base)",
              }}
            >
              <Icon
                src={
                  select === 3
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              3,000C
            </RowView>
            300,000원
          </SelectDiv>

          <SelectDiv
            $select={select === 4}
            onClick={() => {
              setChargeCoin(4000);
              setSelect(4);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-family-base)",
              }}
            >
              <Icon
                src={
                  select === 4
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              4,000C
            </RowView>
            400,000원
          </SelectDiv>
          <SelectDiv
            $select={select === 5}
            onClick={() => {
              setChargeCoin(5000);
              setSelect(5);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-family-base)",
              }}
            >
              <Icon
                src={
                  select === 5
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              5,000C
            </RowView>
            500,000원
          </SelectDiv>

          <SelectDiv
            $select={select === 6}
            onClick={() => {
              setChargeCoin(0);
              setSelect(6);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-family-base)",
              }}
            >
              <Icon
                src={
                  select === 6
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              직접입력
            </RowView>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontSize: 18,
                width: "50%",
                gap: "var(--space-2)",
                minWidth: 0,
              }}
            >
              <CoinInput
                type="number"
                aria-label="직접입력 충전 코인"
                value={select === 6 ? chargeCoin : 0}
                style={{ color: select !== 6 ? "var(--admin-theme-muted, #c6c6c6)" : "var(--admin-theme-text, black)" }}
                disabled={select !== 6}
                onChange={handleChargeCoin}
              />
              C
            </div>
          </SelectDiv>
        </CoinGrid>
        <NoticeDiv>
          <div className="title">요금 안내</div>
          <div>
            • 시청자 수 100명에 1시간 방송시 약 381코인(38,020원)이 소모됩니다.
          </div>
          <div style={{ marginTop: 8 }}>
            • 방송예약 요금은 환율에 따라 변동될 수 있습니다.
          </div>
        </NoticeDiv>
        </ModalBody>
        <ModalFooter>
        <PriceDiv>
          결제 금액
          <div className="price">{amountFormat(chargeCoin * 100)}원</div>
        </PriceDiv>
        <BtnDiv>
          <ApplyBtn disabled={!Number.isSafeInteger(chargeCoin) || chargeCoin <= 0 || chargeCoin > 2147483647} onClick={handleCheckModal}>
            충전하기
          </ApplyBtn>
        </BtnDiv>
        </ModalFooter>
      </ModalBox>
      {checkVisible && <CheckModal
        visible={checkVisible}
        handleModal={handleCheckModal}
        chargeCoin={chargeCoin}
        myCoin={myCoin}
        handleCharge={closeModal}
        handleReload={handleReload}
      />}
    </Container>
  );
};
export default CoinChargeModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  box-sizing: border-box;
  padding: var(--space-4);
  overflow: hidden;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 64rem;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background-color: var(--admin-theme-surface, white);
  color: var(--admin-ink);
  border-radius: 8px;
  padding: 0;
  div.info {
    color: var(--admin-muted);
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
  max-height: 100%;
  overflow: hidden;
`;

const ModalHeader = styled.div`
  flex-shrink: 0;
  padding: var(--space-6) var(--space-6) 0;
`;

const ModalBody = styled.div`
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0 var(--space-6);
`;

const ModalFooter = styled.div`
  flex-shrink: 0;
  border-top: 1px solid var(--color-border-default);
  padding: var(--space-6);
  padding-bottom: max(var(--space-6), env(safe-area-inset-bottom));
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
  margin-top: var(--space-4);
`;

const Btn = styled.button`
  border: 0;
  border-radius: 8px;
  height: 44px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  cursor: pointer;
`;

const ApplyBtn = styled(Btn)`
  background: ${(props) =>
    props.disabled ? "var(--admin-muted)" : "linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep))"};

  color: white;
`;

const MyCoinDiv = styled.div`
  padding: 22px 24px;
  margin-top: 24px;
  border-radius: 8px;
  background-color: var(--admin-theme-accent-soft, #ede8ff);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  .blue {
    color: var(--admin-theme-link, var(--admin-accent-deep));
    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
    font-size: 22px;
  }
`;

const CoinGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-3);
  margin-top: var(--space-4);

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const SelectDiv = styled.div<{ $select: boolean }>`
  box-sizing: border-box;
  min-width: 0;
  border-radius: 8px;
  border: 1px solid;
  border-color: ${(props) => (props.$select ? "var(--admin-accent-deep)" : "var(--admin-theme-border, #f0f0f0)")};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 24px;
  width: 100%;
  cursor: pointer;
  font-size: 18px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
`;

const CoinInput = styled.input`
  box-sizing: border-box;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  height: var(--control-lg);
  padding: var(--space-2) var(--space-3);
  min-width: 0;
  &:focus-visible {
    outline: none;
    border-color: var(--color-brand);
    box-shadow: var(--shadow-focus);
  }
  &:disabled {
    background-color: var(--color-bg-muted);
    border-color: var(--color-border-default);
    cursor: not-allowed;
  }
  text-align: right;
  color: var(--admin-theme-text, black);
  font-size: 18px;
  width: 100%;
  background-color: var(--admin-theme-surface, white);
  /* 화살표 제거 - Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const NoticeDiv = styled.div`
  padding: 30px 0px;
  .title {
    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
    color: var(--admin-theme-text, black);
    margin-bottom: 16px;
  }
  color: var(--admin-muted);
`;

const PriceDiv = styled(RowView)`
  font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  .price {
    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
    font-size: 22px;
    color: var(--admin-theme-danger, #eb003b);
  }
  margin-top: 0;
`;
